import {
    authenticatedApi,
    ApiError,
    API_BASE_URL
} from './apiUtils';

export const teamsApi = {
  getTeamHierarchy: async (projectId) => {
    try {
      return await authenticatedApi.get(`${API_BASE_URL}/projects/${projectId}/team-hierarchy`);
    } catch (error) {
      throw new ApiError(error.message, error.status);
    }
  },

  createTeam: async (teamData) => {
    try {
      return await authenticatedApi.post(`${API_BASE_URL}/teams`, teamData);
    } catch (error) {
      throw new ApiError(error.message, error.status);
    }
  },

  updateTeam: async (teamId, teamData) => {
    try {
      return await authenticatedApi.put(`${API_BASE_URL}/teams/${teamId}`, teamData);
    } catch (error) {
      throw new ApiError(error.message, error.status);
    }
  },

  deleteTeam: async (teamId) => {
    try {
      return await authenticatedApi.delete(`${API_BASE_URL}/teams/${teamId}`);
    } catch (error) {
      throw new ApiError(error.message, error.status);
    }
  },

  assignEmployee: async (teamId, employeeId) => {
    try {
      return await authenticatedApi.post(`${API_BASE_URL}/teams/${teamId}/employees/${employeeId}`);
    } catch (error) {
      throw new ApiError(error.message, error.status);
    }
  },

  moveEmployee: async ({ projectId, employeeId, newTeamId }) => {
    try {
      return await authenticatedApi.post(`${API_BASE_URL}/teams/move-employee`, {
        projectId,
        employeeId,
        newTeamId
      });
    } catch (error) {
      throw new ApiError(error.message, error.status);
    }
  },

  moveTeam: async ({ sourceTeamId, destinationTeamId }) => {
    try {
      return await authenticatedApi.post(`${API_BASE_URL}/teams/move-team`, {
        sourceTeamId,
        destinationTeamId
      });
    } catch (error) {
      throw new ApiError(error.message, error.status);
    }
  },

  getTeamManagerHistory: async (teamId) => {
    try {
      return await authenticatedApi.get(`${API_BASE_URL}/teams/${teamId}/manager-history`);
    } catch (error) {
      if (error.status === 404) {
        throw new ApiError('Team not found', 404);
      }
      throw new ApiError('Failed to fetch team manager history', error.status || 500);
    }
  },
};